import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";

import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import { InputAdornment, TextField } from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const MdlCondicionesLineaCredito = ({ folio, setLoader, loader }) => {
  const [openComentarios, setOpenComentarios] = useState(false);
  const [comentarios, setComentarios] = useState("");
  const [accion, setAccion] = useState("");
  const [estatus, setEstatus] = useState({});
  const [condiciones, setCondiciones] = useState({})
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 7,
      responsable: "C",
    };
    request
      .post(`ACAnalisisDecicion`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);


  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACAnalisisDecicion/Condiciones?folio=${folio}`)
      .then((result) => {
        // setLoader({ ...loader, mostrar: false });
        setCondiciones(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);

  // console.log(condiciones)
  const onEnviarComentario = () => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 7,
      consecutivo: -1,
      comentarios,
      estatus: accion,
    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onAceptar = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 7,
      consecutivo: -1,
      comentarios: "CONDICIONES APROBADAS",
      estatus: "A",

    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  return (
    <div className="analisis-credito-modal-pedido">
      <div className="analisis-credito-modal-pedido-content">
        <div className="analisis-credito-modal-pedido-content-title">
          <div className="analisis-credito-modal-pedido-content-title-text">
            VALIDAR CONDICIONES DE CREDITO
          </div>
          <div className="analisis-credito-modal-pedido-content-title-estimate">
            TIEMPO DE RESPUESTA ESTIMADO: {estatus.tiempoestimado}
          </div>
        </div>
        <div className="analisis-credito-modal-pedido-content-buttons">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <></>
          ) : (
            <div className="analisis-credito-modal2-pedido-content-all-control">
              <div
                className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline analisis-credito-modal-pedido-content-condiciones-credito-timeline`}
              >
                <label>CONDICIONES</label>
                <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg">
                  {/* <OnGetIcon icon={estatus.icono} /> */}
                </div>
                <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div">
                  {condiciones.condiciones}
                </div>
              </div>
              <div
                className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline analisis-credito-modal-pedido-content-condiciones-credito-timeline`}
              >
                <label>OBSERVACIONES</label>
                <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg">
                  {/* <OnGetIcon icon={estatus.icono} /> */}
                </div>
                <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div">
                  {condiciones.observaciones}
                </div>
              </div>
              <div className="analisis-condiciones-credito-timeline-two-labels">
                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels`}
                >
                  <label>DEPOSITO</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-two-labels">
                    <AttachMoneyIcon />
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-two-labels">
                    {condiciones.deposito}
                  </div>
                </div>                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels`}
                >
                  <label>ANTICIPO</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-two-labels">
                    <AttachMoneyIcon />
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-two-labels">
                    {condiciones.anticipo}
                  </div>
                </div>
              </div>
              <div className="analisis-condiciones-credito-timeline-three-labels">
                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                >
                  <label>TASA</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">                  
                    <PercentIcon/>
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                    {condiciones.taza}
                  </div>
                </div>
                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                >
                  <label>PLAZO</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">
                    <CalendarMonthIcon/>
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                    {condiciones.plazo}
                  </div>
                </div>                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                >
                  <label>TIEMPO</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">
                    <AccessTimeIcon/>
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                    {condiciones.tiempo_plazo}
                  </div>
                </div>
              </div>
              <div className="analisis-credito-modal2-pedido-content-control-buttons">
                <div
                  className="analisis-credito-modal2-pedido-content-acept-button"
                  onClick={() => {
                    onAceptar();
                  }}
                >
                  <CheckCircleIcon />
                  <div>ACEPTAR</div>
                </div>
                <div
                  className="analisis-credito-modal2-pedido-content-warning-button"
                  onClick={() => {
                    setOpenComentarios(!openComentarios);
                    setAccion("M");
                  }}
                >
                  <WarningIcon />
                  <div>MODIFICAR</div>
                </div>
                <div
                  className="analisis-credito-modal2-pedido-content-cancel-button"
                  onClick={() => {
                    setOpenComentarios(!openComentarios);
                    setAccion("R");
                  }}
                >
                  <CancelIcon />
                  <div>RECHAZAR</div>
                </div>
              </div>
            </div>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <div
              className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
            >
              <label>Comentarios</label>
              <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-pedido-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ))}
      </div>
      <div className="analisis-credito-modal-condiciones-credito-timeline-footer">
        {openComentarios && (
          <TextField
            fullWidth
            size="small"
            label="COMENTARIOS"
            className="cel-1"
            multiline
            rows={4}
            type="text"
            sx={{backgroundColor:'#fff',marginTop:1}}
            // error={condiciones.bcondiciones}
            onChange={({ target }) => {
              ValSpecialCharacters(
                "condiciones",
                target.value,
                onChange,
                true,
                500
              );
            }}
            value={comentarios}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CancelScheduleSendIcon
                    onClick={() => onEnviarComentario()}
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default MdlCondicionesLineaCredito;
